import Inquiry from 'app/shared/model/Inquiry';

const Conversation = ({
    conversationId = '',
    inquiry = {},
    listingId = '',
    address = '',
} = {}) => ({
    conversationId: String(conversationId),
    inquiry: Inquiry(inquiry),
    listingId: String(listingId),
    address: String(address),
});

export default Conversation;
